export default __webpack_public_path__ + "static/media/sem2.6e6e9c6b.JPG";